import React, { useEffect, createElement } from 'react';
import { WhitePaper } from './pages/WhitePaper';
import { ModalProvider } from './components/ModalContext';
export function App() {
  useEffect(() => {
    // PostHog
    ;
    (function (t: Document, e: any) {
      var o: string[], n: number, p: HTMLScriptElement, r: HTMLScriptElement;
      if (!e.__SV) {
        ;
        (window as any).posthog = e;
        e._i = [];
        e.init = function (i: string, s: any, a?: string) {
          function g(t: any, e: string) {
            var o = e.split('.');
            if (o.length === 2) {
              t = t[o[0]];
              e = o[1];
            }
            t[e] = function () {
              t.push([e].concat(Array.prototype.slice.call(arguments, 0)));
            };
          }
          p = t.createElement('script') as HTMLScriptElement;
          p.type = 'text/javascript';
          p.async = true;
          p.src = s.api_host.replace('.i.posthog.com', '-assets.i.posthog.com') + '/static/array.js';
          t.head.appendChild(p);
          var u: any = e;
          if (a !== undefined) {
            u = e[a] = [];
          } else {
            a = 'posthog';
          }
          u.people = u.people || [];
          u.toString = function (t?: any) {
            var e = 'posthog';
            if (a !== 'posthog') e += '.' + a;
            if (!t) e += ' (stub)';
            return e;
          };
          u.people.toString = function () {
            return u.toString(1) + '.people (stub)';
          };
          o = 'init capture register register_once register_for_session unregister opt_out_capturing has_opted_out_capturing opt_in_capturing reset isFeatureEnabled getFeatureFlag getFeatureFlagPayload reloadFeatureFlags group identify setPersonProperties setPersonPropertiesForFlags resetPersonPropertiesForFlags setGroupPropertiesForFlags resetGroupPropertiesForFlags resetGroups onFeatureFlags addFeatureFlagsHandler onSessionId getSurveys getActiveMatchingSurveys renderSurvey canRenderSurvey getNextSurveyStep'.split(' ');
          for (n = 0; n < o.length; n++) g(u, o[n]);
          e._i.push([i, s, a]);
        };
        e.__SV = 1;
      }
    })(document, (window as any).posthog || []);
    (window as any).posthog.init('phc_EZt3xuIH4N7zt9KKTtqfttkgwvwvh7NObmOqB614t8s', {
      api_host: 'https://us.i.posthog.com',
      defaults: '2026-01-30'
    });
    // Google Analytics
    const gtagScript = document.createElement('script');
    gtagScript.async = true;
    gtagScript.src = 'https://www.googletagmanager.com/gtag/js?id=G-E0RK62S7ZM';
    document.head.appendChild(gtagScript);
    (window as any).dataLayer = (window as any).dataLayer || [];
    function gtag(...args: any[]) {
      ;
      (window as any).dataLayer.push(arguments);
    }
    gtag('js', new Date());
    gtag('config', 'G-E0RK62S7ZM');
  }, []);
  return <ModalProvider data-id="element-0">
      <div className="w-full min-h-screen bg-white text-gray-800 font-sans" data-id="element-1">
        <WhitePaper data-id="element-2" />
      </div>
    </ModalProvider>;
}